import type { MeetingCardData } from '../types';
import { formatDate, formatTime, meetingDayState } from '../lib/utils';
import MeetingRelationBadge from './MeetingRelationBadge';

export default function MeetingCard({ meeting, onOpen, isNearestActiveUpcoming = false }: {
  meeting: MeetingCardData;
  onOpen: () => void;
  isNearestActiveUpcoming?: boolean;
}) {
  const dayState = meetingDayState(meeting.meeting_date);
  const timingLabel = meeting.status !== 'Active'
    ? 'Dibatalkan'
    : dayState === 'today'
      ? 'Hari ini'
      : dayState === 'future'
        ? 'Akan datang'
        : 'Terdahulu';

  const tone = meeting.status !== 'Active'
    ? 'meeting-card-cancelled'
    : dayState === 'past'
      ? 'meeting-card-past'
      : isNearestActiveUpcoming ? 'meeting-card-nearest' : 'meeting-card-upcoming';
  const timeLabel = formatTime(meeting.meeting_time);

  return (
    <button className={`meeting-card meeting-card-${dayState} ${tone}`} onClick={onOpen}>
      <div className="meeting-card-top">
        <span className={`status-pill ${meeting.status === 'Active' ? 'status-active' : 'status-cancelled'}`}>{timingLabel}</span>
        <div className="meeting-card-pills">
          <MeetingRelationBadge relationship={meeting.relationship} />
        </div>
      </div>
      <h3>{meeting.title}</h3>
      <div className="meeting-meta">
        <span>📅 {formatDate(meeting.meeting_date)}</span>
        <span>🕒 {timeLabel}</span>
        {meeting.location && <span>📍 {meeting.location}</span>}
        {meeting.chairman && <span>Pengerusi: {meeting.chairman}</span>}
        <span><em>Host</em>: {meeting.host_email}</span>
      </div>
      <div className="meeting-count"><strong>{meeting.checked_in_count}</strong><span>telah hadir</span></div>
    </button>
  );
}
